import { useState } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/layout/Container";
import PageTitleBox from "@/components/common/PageTitleBox";

const ServiceTest = () => {
  // 안내 모달 상태
  const [showGuideModal, setShowGuideModal] = useState(true);

  return (
    <Container>
      <main className="py-[60px]">
        {/* 안내 모달 */}
        {showGuideModal && (
          <div
            className="fixed inset-0 flex justify-center items-center z-[1000]"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          >
            <div
              className="bg-white"
              style={{
                padding: "30px 40px",
                borderRadius: "12px",
                width: "460px",
                boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
              }}
            >
              <h3
                className="text-left pb-3 mb-[15px]"
                style={{
                  borderBottom: "1px solid #e5e5e5",
                  fontSize: "1.8rem",
                  fontWeight: "bold",
                  color: "#1a1a1a",
                }}
              >
                안내
              </h3>
              <div className="py-4 text-center">
                <p className="text-[1.5rem] text-gray-7 mb-2">메시지 서비스 테스트는</p>
                <p className="text-[1.5rem] text-gray-7 mb-2">
                  우선{" "}
                  <Link
                    to="/service/submit?type=messaging"
                    className="text-[#4361ee] font-semibold hover:underline"
                  >
                    서비스 이용 신청
                  </Link>{" "}
                  후,
                </p>
                <p className="text-[1.5rem] text-gray-7">
                  <span className="text-[#4361ee] font-semibold">테스트 계정</span>을 발급받아
                  이용하실 수 있습니다.
                </p>
              </div>
              <div className="flex justify-center gap-3 mt-6">
                <Link
                  to="/service/submit?type=messaging"
                  className="px-5 py-3 bg-[#032C6D] text-white rounded-lg text-[1.4rem] font-medium hover:bg-[#1e1d4a] transition-colors"
                >
                  서비스 이용 신청하기
                </Link>
                <button
                  type="button"
                  onClick={() => setShowGuideModal(false)}
                  className="px-5 py-3 border border-gray-3 rounded-lg text-[1.4rem] font-medium hover:bg-gray-50 transition-colors"
                >
                  이미 신청했어요
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Hero Section */}
        <PageTitleBox
          badge="서비스 테스트 진행"
          badgeColor="gray"
          title={
            <>
              Agent와 API를 연동하여
              <br />
              지금 바로 메시지 발송 테스트를 시작해보세요
            </>
          }
          showSeparator={false}
        />

        {/* 기술 지원 요청 링크 */}
        <div className="flex items-center justify-end gap-2 mt-8 mb-4">
          <span className="text-[1.4rem] text-gray-5">테스트 과정에서 어려움이 있으신가요?</span>
          <a
            href="/voc/submit"
            className="px-4 py-2 border border-gray-3 rounded text-[1.4rem] hover:bg-gray-50 transition-colors"
          >
            기술 지원 요청하기
          </a>
        </div>

        {/* Agent, API 명세서 다운로드 */}
        <section className="mb-[80px]">
          <h2 className="text-[2rem] font-bold text-[#4361ee] mb-8 pb-3 border-b border-gray-2">
            Agent, API 명세서 다운로드
          </h2>

          <div className="flex justify-center gap-4 mb-6">
            <a
              href="/file/agent-download.zip"
              download
              className="flex items-center gap-2 px-8 py-4 bg-[#032C6D] text-white rounded-full text-[1.5rem] font-medium hover:bg-[#1e1d4a] transition-colors"
            >
              Agent 다운로드 받기
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </a>
            <a
              href="/file/Standard_Networks_UMS_API-v1.0.3.pdf"
              download
              className="flex items-center gap-2 px-8 py-4 bg-[#4361ee] text-white rounded-full text-[1.5rem] font-medium hover:bg-[#3651de] transition-colors"
            >
              API 명세서 다운로드 받기
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </a>
          </div>

          <p className="text-center text-[1.4rem] text-gray-5 mb-1">파일 용량은 약 100MB 입니다.</p>
          <p className="text-center text-[1.4rem] text-gray-5">
            설치 후 테스트 시나리오 가이드에 따라 순서대로 테스트를 진행해주세요.
          </p>
        </section>

        {/* 테스트 시나리오 가이드 */}
        <section className="mb-[80px]">
          <h2 className="text-[2rem] font-bold text-black mb-4">테스트 시나리오 가이드</h2>
          <p className="text-[1.5rem] text-gray-6 mb-2">
            Agent 설치가 완료된 후, 상용 연동 전 테스트를 진행하기 위한 가이드입니다.
          </p>
          <p className="text-[1.5rem] text-gray-6 mb-8">
            기본적인 설정 파일 수정 방법과 DB를 이용한 메시지 발송 및 결과 확인 방법을 안내합니다.
          </p>

          {/* Guide Section 1 */}
          <div className="mb-6 overflow-hidden border rounded-lg border-gray-2">
            <div className="px-6 py-4 bg-white border-b border-gray-2">
              <h3 className="text-[1.6rem] font-bold text-black">1. application.yml 기본 설정</h3>
            </div>

            <div className="p-6 bg-[#fafafa]">
              <div className="flex items-center gap-2 mb-4">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#4361ee">
                  <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
                </svg>
                <span className="text-[1.4rem] text-[#4361ee] font-medium">설정 파일 위치</span>
              </div>
              <p className="text-[1.4rem] text-gray-6 mb-6">
                Agent 설치 폴더 내 conf/application.yml 파일을 열어 수정해 주세요.
              </p>

              <p className="text-[1.4rem] text-gray-6 mb-4">
                테스트 연동을 위해 위 경로의 파일에서 아래 항목들을 설정해야 합니다. (기타 옵션은
                매뉴얼 참조)
              </p>

              {/* 1-1. ClientConfig */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  1-1. 클라이언트 및 연동 정보 (ClientConfig)
                </h4>

                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div>
                    <span className="text-[#9cdcfe]">clientConfig</span>:
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">memberId</span>:{" "}
                    <span className="text-[#ce9178]">"발급 받은 아이디"</span>
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">memberPw</span>:{" "}
                    <span className="text-[#ce9178]">"발급 받은 패스워드"</span>
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">clientKey</span>:{" "}
                    <span className="text-[#ce9178]">"발급 받은 클라이언트 키"</span>
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">targetUrl</span>:{" "}
                    <span className="text-[#ce9178]">
                      "스탠다드네트웍스 URL 1", "스탠다드네트웍스 URL 2"
                    </span>{" "}
                    <span className="text-[#9cdcfe]">type</span>:{" "}
                    <span className="text-[#ce9178]">"sms,mms,rcs,kko"</span>{" "}
                    <span className="text-[#9cdcfe]">tps</span>:{" "}
                    <span className="text-[#b5cea8]">200</span>
                  </div>
                </div>

                <ul className="space-y-2 text-[1.4rem] text-gray-6">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>targetUrl</strong> : Agent가 연결할 Gateway 주소 (단일 주소인 경우
                      하나만 입력)
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>type</strong> : 계약된 사용 서비스만 입력 (예: sms,mms)
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>tps</strong> : 초당 발송량 (권장 최대 200)
                    </span>
                  </li>
                </ul>
              </div>

              {/* 1-2. DataSource */}
              <div>
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  1-2. 데이터베이스 접속 정보 (DataSource)
                </h4>

                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div>
                    <span className="text-[#9cdcfe]">spring</span>:
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">datasource</span>:
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">driver-class-name</span>:{" "}
                    <span className="text-[#ce9178]">com.mysql.cj.jdbc.Driver</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">url</span>:{" "}
                    <span className="text-[#ce9178]">jdbc:mysql://localhost:3306/sms_db</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">username</span>:{" "}
                    <span className="text-[#ce9178]">your_username</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">password</span>:{" "}
                    <span className="text-[#ce9178]">your_password</span>
                  </div>
                </div>

                <ul className="space-y-2 text-[1.4rem] text-gray-6">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>지원 DB: MySQL, MariaDB, Oracle, PostgreSQL, MSSQL</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>DB 유형에 맞는 driver-class-name 설정 필요</span>
                  </li>
                </ul>
              </div>

              {/* 1-3. DBConfig */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  1-3. 테이블 및 스키마 설정 (DBConfig)
                </h4>
                <p className="text-[1.4rem] text-gray-6 mb-4">
                  메시지를 적재할 테이블명과 스키마를 지정합니다.
                </p>

                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div>
                    <span className="text-[#9cdcfe]">dbConfig</span>:
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">database</span>:
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">schemaName</span>:{" "}
                    <span className="text-[#ce9178]">"test"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">smsTableName</span>:{" "}
                    <span className="text-[#ce9178]">"TEST_SMS"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">mmsTableName</span>:{" "}
                    <span className="text-[#ce9178]">"TEST_MMS"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">imgTableName</span>:{" "}
                    <span className="text-[#ce9178]">"TEST_FILE"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">rcsTableName</span>:{" "}
                    <span className="text-[#ce9178]">"TEST_RCS"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">kkoTableName</span>:{" "}
                    <span className="text-[#ce9178]">"TEST_KKO"</span>
                  </div>
                  <div className="pl-8">
                    <span className="text-[#9cdcfe]">ignoreTime</span>:{" "}
                    <span className="text-[#b5cea8]">72</span>
                  </div>
                </div>

                <ul className="space-y-2 text-[1.4rem] text-gray-6">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>schemaName</strong> : 테이블이 생성된 스키마명
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>smsTableName</strong> : SMS 문자 발송 테이블명
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>mmsTableName</strong> : LMS/MMS 문자 발송 테이블명
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>ignoreTime</strong> : 데이터 조회 범위 (시간 단위, 예: 72 입력 시
                      72시간 전 데이터까지 조회)
                    </span>
                  </li>
                </ul>
              </div>

              {/* 1-4. Webhook */}
              <div>
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  1-4. 결과 수신 포트 (Webhook)
                </h4>

                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div>
                    <span className="text-[#9cdcfe]">server</span>:
                  </div>
                  <div className="pl-4">
                    <span className="text-[#9cdcfe]">port</span>:{" "}
                    <span className="text-[#b5cea8]">9960</span>
                  </div>
                </div>

                <div className="bg-[#eef6ff] border-l-4 border-[#3b82f6] p-4 rounded-r">
                  <p className="text-[1.4rem] text-gray-7">
                    방화벽에서 해당 <strong>PORT(9960)</strong>가 인바운드 허용되어 있어야
                    결과(Report)를 정상적으로 수신할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Guide Section 2 */}
          <div className="mb-6 overflow-hidden border rounded-lg border-gray-2">
            <div className="px-6 py-4 bg-white border-b border-gray-2">
              <h3 className="text-[1.6rem] font-bold text-black">2. 에이전트 기동 및 연결 점검</h3>
            </div>

            <div className="p-6 bg-[#fafafa]">
              <p className="text-[1.4rem] text-gray-6 mb-4">
                설정이 완료되면 에이전트를 기동하기 전에 <strong>DB 연결 상태</strong>를 먼저
                확인하고 기동해야 합니다.
              </p>

              <div className="bg-[#fff3cd] border-l-4 border-[#ffc107] p-4 mb-6 rounded-r">
                <p className="text-[1.4rem] text-gray-7">
                  <strong>📂 실행 경로</strong>
                  <br />
                  Agent 설치 폴더 내{" "}
                  <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">bin</code> 폴더로
                  이동하여 진행해 주세요.
                </p>
              </div>

              {/* 2-1. DB Check */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  2-1. DB 연결 테스트 (dbCheck)
                </h4>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  작성하신 설정 파일 정보를 바탕으로 DB 접속이 가능한지 확인합니다.
                </p>
                <ul className="space-y-2 text-[1.4rem] text-gray-6 mb-4">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>Linux:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        ./dbCheck.sh
                      </code>{" "}
                      실행
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>Windows:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        dbCheck.bat
                      </code>{" "}
                      실행
                    </span>
                  </li>
                </ul>

                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div className="text-gray-5">[실행 결과 예시]</div>
                  <div>Start DB Check!!!</div>
                  <div>...</div>
                  <div className="text-[#10b981] font-bold">Connect to Database Success!!!</div>
                </div>

                <p className="text-[1.3rem] text-[#ef4444]">
                  ※ "Connect to Database Success!!!" 메시지가 나오지 않는 경우, 1번 설정의 DB 접속
                  정보를 다시 확인해주세요.
                </p>
              </div>

              {/* 2-2. Start */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  2-2. 에이전트 기동 (Start)
                </h4>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  DB 연결이 성공했다면 에이전트를 구동합니다.
                </p>
                <ul className="space-y-2 text-[1.4rem] text-gray-6">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>Linux:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        ./start.sh
                      </code>{" "}
                      실행
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>Windows:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        start.bat
                      </code>{" "}
                      실행
                    </span>
                  </li>
                </ul>
              </div>

              {/* 2-3. 기동 확인 */}
              <div>
                <h4 className="text-[1.5rem] font-bold text-black mb-4">2-3. 기동 정상 확인</h4>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  스크립트 실행 후, 정상적으로 기동되었는지 확인합니다.
                </p>
                <ul className="space-y-2 text-[1.4rem] text-gray-6 mb-4">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>PID 파일 확인:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">bin</code> 폴더
                      내에{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        application.pid
                      </code>{" "}
                      파일이 생성되었는지 확인
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>로그 확인:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">logs</code>{" "}
                      폴더 내 로그 파일에 Error 문구가 없는지 확인
                    </span>
                  </li>
                </ul>
                <div className="bg-[#eef6ff] border-l-4 border-[#3b82f6] p-4 rounded-r">
                  <p className="text-[1.4rem] text-gray-7">
                    위 두 가지(PID 생성, 로그 에러 없음)가 확인되면 <strong>정상 기동</strong>{" "}
                    상태입니다.
                    <br />
                    이제 3번 테스트 발송을 진행해 주세요.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Guide Section 3 */}
          <div className="mb-6 overflow-hidden border rounded-lg border-gray-2">
            <div className="px-6 py-4 bg-white border-b border-gray-2">
              <h3 className="text-[1.6rem] font-bold text-black">
                3. 테스트 문자 발송 (DB INSERT)
              </h3>
            </div>

            <div className="p-6 bg-[#fafafa]">
              <p className="text-[1.4rem] text-gray-6 mb-4">
                메시지 발송 테스트는 DB 테이블에 데이터를 INSERT 하는 방식으로 진행됩니다.
              </p>

              <div className="bg-[#eef6ff] border-l-4 border-[#3b82f6] p-4 mb-6 rounded-r">
                <p className="text-[1.4rem] text-gray-7 font-bold mb-2">공통 필수값 설명</p>
                <ul className="space-y-1 text-[1.4rem] text-gray-6">
                  <li>
                    • <code className="bg-white px-2 py-1 rounded text-[#c7254e]">SRC_MSG_ID</code>{" "}
                    : 고객사에서 관리하는 메시지 고유 ID (PK 권장)
                  </li>
                  <li>
                    • <code className="bg-white px-2 py-1 rounded text-[#c7254e]">BILL_CD</code> :
                    발급 받은 과금 코드 5자리 (광고/일반 구분)
                  </li>
                  <li>
                    •{" "}
                    <code className="bg-white px-2 py-1 rounded text-[#c7254e]">CMP_SND_DTTM</code>{" "}
                    : 발송 요청 시간 (Format: YYYYMMDDHHMISS)
                    <br />
                    <span className="text-[#e65100] text-[1.3rem]">
                      ※ 미래 시간으로 입력 시 자동으로 <strong>예약 발송</strong> 처리됩니다.
                    </span>
                  </li>
                  <li>
                    •{" "}
                    <code className="bg-white px-2 py-1 rounded text-[#c7254e]">TRANS_CO_CODE</code>{" "}
                    : (특수부가통신사업자만 해당) KISA에서 발급받은 최초발신자식별번호
                  </li>
                </ul>
              </div>

              {/* SMS 예제 */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">SMS 발송 예제</h4>
                <div className="bg-[#1e1e1e] rounded-lg p-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8] overflow-x-auto">
                  <div>
                    <span className="text-[#569cd6]">INSERT INTO</span>{" "}
                    &#123;스키마명&#125;.&#123;테이블명&#125;
                  </div>
                  <div>
                    (SRC_MSG_ID, CALLBACK, RECEIVER, CONTENT, BILL_CD, TRANS_CO_CODE, CMP_SND_DTTM)
                  </div>
                  <div>
                    <span className="text-[#569cd6]">VALUES</span>
                  </div>
                  <div>
                    (<span className="text-[#ce9178]">'1'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'SMS 테스트 메시지 입니다.'</span>,
                  </div>
                  <div>
                    <span className="text-[#ce9178]">'XXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'XXXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'20240101000000'</span>);
                  </div>
                </div>
              </div>

              {/* LMS 예제 */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">LMS 발송 예제</h4>
                <div className="bg-[#1e1e1e] rounded-lg p-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8] overflow-x-auto">
                  <div>
                    <span className="text-[#569cd6]">INSERT INTO</span>{" "}
                    &#123;스키마명&#125;.&#123;테이블명&#125; (
                  </div>
                  <div className="pl-4">SRC_MSG_ID, CALLBACK, RECEIVER, SUBJECT, CONTENT,</div>
                  <div className="pl-4">BILL_CD, TRANS_CO_CODE, CMP_SND_DTTM</div>
                  <div>
                    ) <span className="text-[#569cd6]">VALUES</span> (
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'1'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'제목입니다.'</span>,{" "}
                    <span className="text-[#ce9178]">'LMS 테스트 메시지 입니다.'</span>,
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'XXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'XXXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'20240101000000'</span>
                  </div>
                  <div>);</div>
                </div>
              </div>

              {/* MMS 예제 */}
              <div>
                <h4 className="text-[1.5rem] font-bold text-black mb-4">
                  MMS 발송 예제 (이미지 포함)
                </h4>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  MMS 발송을 위해서는 이미지가 먼저 등록되어야 합니다.
                </p>

                <p className="text-[1.4rem] font-semibold text-gray-7 mb-2">step 1. 이미지 등록</p>
                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-2 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8] overflow-x-auto">
                  <div>
                    <span className="text-[#569cd6]">INSERT INTO</span>{" "}
                    &#123;스키마명&#125;.&#123;이미지테이블명&#125; ( IMG_PATH ){" "}
                    <span className="text-[#569cd6]">VALUES</span> (
                    <span className="text-[#ce9178]">'/home/agent/images/test.jpg'</span>);
                  </div>
                </div>
                <p className="text-[1.3rem] text-[#ef4444] mb-4">
                  * 이미지 파일은 Agent 서버의 지정된 경로에 실제로 존재해야 합니다.
                </p>

                <p className="text-[1.4rem] font-semibold text-gray-7 mb-2">
                  step 2. MMS 발송 (FILE_IDS에 등록된 ID 입력)
                </p>
                <div className="bg-[#1e1e1e] rounded-lg p-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8] overflow-x-auto">
                  <div>
                    <span className="text-[#569cd6]">INSERT INTO</span>{" "}
                    &#123;스키마명&#125;.&#123;테이블명&#125; (
                  </div>
                  <div className="pl-4">SRC_MSG_ID, CALLBACK, RECEIVER, SUBJECT, CONTENT,</div>
                  <div className="pl-4">BILL_CD, TRANS_CO_CODE, CMP_SND_DTTM, FILE_IDS</div>
                  <div>
                    ) <span className="text-[#569cd6]">VALUES</span> (
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'1'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'010XXXXXXXX'</span>,
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'제목입니다.'</span>,{" "}
                    <span className="text-[#ce9178]">'MMS 테스트 메시지 입니다.'</span>,
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'XXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'XXXXXXXXX'</span>,{" "}
                    <span className="text-[#ce9178]">'20240101000000'</span>,
                  </div>
                  <div className="pl-4">
                    <span className="text-[#ce9178]">'fileId1,fileId2'</span>
                  </div>
                  <div>);</div>
                </div>
              </div>
            </div>
          </div>

          {/* Guide Section 4 */}
          <div className="mb-6 overflow-hidden border rounded-lg border-gray-2">
            <div className="px-6 py-4 bg-white border-b border-gray-2">
              <h3 className="text-[1.6rem] font-bold text-black">4. DB 이력 및 로그 확인</h3>
            </div>

            <div className="p-6 bg-[#fafafa]">
              <p className="text-[1.4rem] text-gray-6 mb-4">
                발송 후 <strong>DB 결과 값</strong>과 <strong>Agent 로그</strong>를 교차 검증하여
                성공 여부를 확인합니다.
              </p>

              {/* 4-1. DB 이력 확인 */}
              <div className="mb-6">
                <h4 className="text-[1.5rem] font-bold text-black mb-4">4-1. DB 이력 확인</h4>
                <ul className="space-y-2 text-[1.4rem] text-gray-6">
                  <li className="flex items-start gap-2">
                    <span className="mt-1 text-gray-4">•</span>
                    <span>
                      <strong>조회 키:</strong>{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        SRC_MSG_ID
                      </code>
                      (고객 메시지 ID) 또는{" "}
                      <code className="bg-gray-200 px-2 py-1 rounded text-[#c7254e]">
                        UMS_MSG_ID
                      </code>
                      (Gateway 메시지 ID)
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#10b981] mt-1">•</span>
                    <span className="text-[#10b981] font-bold">성공: RSLT_VAL = -100</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#ef4444] mt-1">•</span>
                    <span className="text-[#ef4444] font-bold">
                      실패: RSLT_VAL ≠ -100 (에이전트 매뉴얼 참조)
                    </span>
                  </li>
                </ul>
              </div>

              {/* 4-2. Agent 로그 확인 */}
              <div>
                <h4 className="text-[1.5rem] font-bold text-black mb-4">4-2. Agent 로그 확인</h4>

                <p className="text-[1.4rem] font-semibold text-gray-7 mb-2">
                  STEP 1. 발송 요청 (SUBMIT)
                </p>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  Agent가 Gateway로 메시지를 정상적으로 보냈는지 확인합니다.
                </p>
                <div className="bg-[#1e1e1e] rounded-lg p-4 mb-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div>Success To put submitAck message to queue</div>
                  <div>SrcMsgId : [고객 메시지 ID]</div>
                  <div>UmsMsgId : [Gateway 메시지 ID]</div>
                </div>

                <p className="text-[1.4rem] font-semibold text-gray-7 mb-2">
                  STEP 2. 결과 수신 (REPORT)
                </p>
                <p className="text-[1.4rem] text-gray-6 mb-3">
                  통신사로부터 최종 전송 결과를 수신했는지 확인합니다.
                </p>
                <div className="bg-[#1e1e1e] rounded-lg p-4 font-mono text-[1.3rem] text-[#d4d4d4] leading-[1.8]">
                  <div className="text-gray-5">/* 성공 로그 예시 */</div>
                  <div>
                    Report Incoming : srcMsgId = [고객 메시지 ID] umsMsgId = [Gateway 메시지 ID]
                    resultCode = <span className="text-[#10b981]">-100</span>
                  </div>
                  <div className="mt-2 text-gray-5">/* 실패 로그 예시 */</div>
                  <div>
                    Report Incoming : srcMsgId = [고객 메시지 ID] umsMsgId = [Gateway 메시지 ID]
                    resultCode = <span className="text-[#ef4444]">[에러코드]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 문의하기 */}
        <section className="text-center py-[40px]">
          <p className="text-[1.5rem] text-gray-6 mb-2">연동 중 문의사항이 있으신가요?</p>
          <p className="text-[1.5rem] text-gray-6 mb-6">
            Agent 연동 및 API 사용에 문제가 있다면 바로 문의해주세요.
          </p>
          <a
            href="/voc/submit"
            className="inline-block px-8 py-4 bg-[#666] text-white rounded-lg text-[1.5rem] font-medium hover:bg-[#555] transition-colors"
          >
            문의하기
          </a>
        </section>
      </main>
    </Container>
  );
};

export default ServiceTest;
